import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isRegister = searchParams.get('mode') === 'register';

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
          console.error('Error getting session:', error);
          navigate('/login?error=auth_failed');
          return;
        }

        if (session?.user) {
          // Obtener perfil existente (incluyendo user_type)
          const { data: existingUser } = await supabase
            .from('users')
            .select('id, name, phone, status, user_type')
            .eq('id', session.user.id)
            .maybeSingle();

          if (!existingUser) {
            // Si es registro y no existe perfil, redirigir a completar perfil
            // (ahora incluye selección de tipo y tenant)
            if (isRegister) {
              navigate('/complete-profile');
              return;
            }
          } else {
            // Si existe perfil pero falta nombre o user_type, redirigir a completar perfil
            if (!existingUser.name || !(existingUser as any).user_type) {
              navigate('/complete-profile');
              return;
            }

            // Si tiene todos los datos, redirigir según estado
            if (existingUser.status === 'active') {
              navigate('/dashboard');
              return;
            } else if (existingUser.status === 'pending_approval') {
              navigate('/waiting-approval');
              return;
            }
          }

          // Redirigir según el modo (login o registro)
          if (isRegister) {
            navigate('/waiting-approval');
          } else {
            navigate('/dashboard');
          }
        } else {
          navigate('/login');
        }
      } catch (error) {
        console.error('Error in auth callback:', error);
        navigate('/login?error=callback_failed');
      }
    };

    handleAuthCallback();
  }, [navigate, isRegister]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completando autenticación...</p>
      </div>
    </div>
  );
}
